import { Component, OnInit, AfterViewInit, Renderer, ElementRef } from '@angular/core';
import { AccountService } from '../../../../services';
import { User, Email } from '../../../../models';

@Component({
    selector: 'qms-password-reset-init',
    templateUrl: './password-reset-init.component.html'
})
export class PasswordResetInitComponent implements OnInit, AfterViewInit {
    public emailMinLength = User.EMAIL_MIN_LENGTH;
    public emailMaxLength = User.EMAIL_MAX_LENGTH; // TODO move to constants

    public accountEmail: string;
    public success: boolean;

    constructor(private accountService: AccountService,
                private elementRef: ElementRef,
                private renderer: Renderer) {
    }

    ngOnInit() {
        this.accountEmail = null;
        this.success = null;
    }

    ngAfterViewInit() {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#email'), 'focus', []);
    }

    public requestReset() {
        const email = new Email(this.accountEmail);
        this.accountService.initializePasswordReset(email).subscribe(() => {
            this.success = true;
        }, (response) => {
            this.success = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/account/password/reset/password-reset-init.component.ts